import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractLocalisationInput} from "../abstract-localisation-input";
import {FUIResponsiveService} from "../../../../page/responsive.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopLocalisationInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-localisation-input",
    templateUrl: "./pop-localisation-input.component.html"
})
export class FUIPopLocalisationInputComponent extends FUIAbstractLocalisationInput {
    constructor(responsiveService: FUIResponsiveService,
                changeDetectorRef: ChangeDetectorRef) {
        super(responsiveService, changeDetectorRef);
    }

    override ngOnInit(): void {
    }
}
